import { render, staticRenderFns } from "./TokenClubAddOnSelectItem.vue?vue&type=template&id=32bc455f&scoped=true"
import script from "./TokenClubAddOnSelectItem.vue?vue&type=script&lang=ts"
export * from "./TokenClubAddOnSelectItem.vue?vue&type=script&lang=ts"
import style0 from "./TokenClubAddOnSelectItem.vue?vue&type=style&index=0&id=32bc455f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32bc455f",
  null
  
)

export default component.exports